import { createHelpers } from '@scalingworks/refine-react-admin';

import type { ServiceRate } from '~/api';

import { resourceNames } from '../resource-names';

export const rateSetupHelpers = createHelpers<ServiceRate>({
	resourceName: resourceNames.rateSetup,
});
